exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overview .overview-card[data-v-669e8b71]{border-radius:3px;box-shadow:0 2px 6px 0 rgba(0,0,0,.2);height:80px;margin-bottom:15px;margin-top:3px;min-height:0;padding:20px 16px 14px;width:100%}.soft-text[data-v-669e8b71]{transform:rotate(.03deg)}.loading-text[data-v-669e8b71]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-669e8b71","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Invoices/data-skybox.vue
// module id = o60s
// module chunks = 12